import { createGame } from "./game";
import { CLASSES, DEFAULT_CLASS_ID } from "@mmo/shared";

const canvas = document.createElement("canvas");
document.body.appendChild(canvas);
const overlay = document.getElementById("overlay") as HTMLDivElement;
const hud = document.getElementById("hud") as HTMLDivElement;
const nameInput = document.getElementById("name-input") as HTMLInputElement;
const classButtons = Array.from(document.querySelectorAll<HTMLButtonElement>(".class-btn"));

function resolveName(): string {
  const url = new URL(location.href);
  const fromUrl = url.searchParams.get("name");
  if (fromUrl) return fromUrl;
  return localStorage.getItem("mmo:name") ?? "";
}

function resolveClass(): string {
  const url = new URL(location.href);
  const fromUrl = url.searchParams.get("class");
  if (fromUrl && CLASSES[fromUrl]) return fromUrl;
  const stored = localStorage.getItem("mmo:class");
  if (stored && CLASSES[stored]) return stored;
  return DEFAULT_CLASS_ID;
}

let selectedClass = resolveClass();
function paintClassSelection() {
  for (const btn of classButtons) {
    btn.classList.toggle("selected", btn.dataset.class === selectedClass);
  }
}
for (const btn of classButtons) {
  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    selectedClass = btn.dataset.class ?? DEFAULT_CLASS_ID;
    localStorage.setItem("mmo:class", selectedClass);
    paintClassSelection();
  });
}
paintClassSelection();

nameInput.value = resolveName();
nameInput.addEventListener("input", () => {
  localStorage.setItem("mmo:name", nameInput.value);
});
nameInput.addEventListener("click", (e) => e.stopPropagation());

const game = createGame(
  canvas,
  hud,
  () => nameInput.value.trim() || `guest-${Math.floor(Math.random() * 999)}`,
  () => selectedClass,
);

overlay.addEventListener("click", (e) => {
  const t = e.target as HTMLElement;
  if (t === nameInput || t.classList.contains("class-btn") || t.closest(".class-btn")) return;
  localStorage.setItem("mmo:name", nameInput.value);
  canvas.requestPointerLock();
});

document.addEventListener("pointerlockchange", () => {
  const locked = document.pointerLockElement === canvas;
  overlay.classList.toggle("hidden", locked);
  game.setPointerLocked(locked);
  if (locked) game.refreshClass();
});

window.addEventListener("resize", () => game.resize());
window.addEventListener("contextmenu", (e) => { if (document.pointerLockElement === canvas) e.preventDefault(); });
game.resize();
game.start();
